<template>
  <div class="info_block_holder row">
    <div class="info_block col-xs-6 border_radius-left">
      <span class="info_block_text" id="position">{{position}}</span><br><span
            class="info_block_text_small">position</span>
    </div>
    <div class="info_block col-xs-6 border_radius-right">
      <span class="info_block_text avg_speed" id="avgspeed">{{avgSpeed}} km/h</span><br><span
            class="info_block_text_small">average speed</span>
    </div>
    <!--<div class="info_block col-xs-6 border_radius-left">-->
    <!--<span class="info_block_text elevation" id="elevationgain">{{elev}} m</span><br><span class="info_block_text_small">elevation gain</span>-->
    <!--</div>-->
    <!--<div class="info_block col-xs-6 border_radius-right">-->
    <!--<span class="info_block_text elevation_remaining" id="elevationleft">{{decs}} m</span><br><span class="info_block_text_small">elevation lost</span>-->
    <!--</div>-->
    <div class="info_block col-xs-6 border_radius-right">
      <span class="info_block_text altitude" id="altitude">{{lastUpdate}}</span><br><span
            class="info_block_text_small">Last Update</span>
    </div>
    <!--<div class="info_block col-xs-6 border_radius-left">-->
      <!--<span class="info_block_text speed" id="athletespeed">{{athl.speed}} km/h</span><br><span-->
            <!--class="info_block_text_small">speed</span>-->
    <!--</div>-->
    <div class="info_block col-xs-6 border_radius-right">
      <span class="info_block_text altitude" id="altitude">{{ath.properties.elevation}} m</span><br><span
            class="info_block_text_small">altitude</span>
    </div>

  </div>

</template>
<style>
</style>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default{
  data: function () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      getAthletes: 'athletes',
      athlete: 'focusedAthlete',
      showPositions: 'raceShowPositions',
      athl: 'athlete'
    }),
    ath: function () {
      return this.getAthletes[this.athlete.id]
    },
    avgSpeed: function () {
        if(this.ath.race_id === 185) {
            return '-'
        }
      let avgspd = (this.ath.properties.distance/this.ath.properties.duration * 3.6).toFixed(2)
      return (this.status === 2 ? '-' : avgspd)
    },
    elev: function () {
      return this.ath.altgain
    },
    decs: function () {
      return this.ath.altlost
    },
    lastUpdate: function() {
      if(this.ath.properties) {
        let now = moment.utc()
        let epoch = this.ath.properties.epoch ? moment.unix(this.ath.properties.epoch) : null
        return epoch !== null ? moment.duration(now.diff(epoch)).humanize() + ' ago' : ''
      }
      return ''
    },
    speed: function () {
      return (this.status === 0 ? this.athlete.properties.speed : '-')
    },
    position: function() {
      return this.showPositions ? this.ath.position : '-'
    },
    status: function () {
      if (typeof (this.ath.Finish) === 'undefined') {
        return 0
      } else if (this.ath.status === 1 || this.ath.status === 2) {
        return 1
      } else {
        return 1
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/athlete/infoblock.vue